import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M15.75 4.91422L4.75 15.9142V19.75H8.58579L19.5858 8.75001L15.75 4.91422ZM4.67705 15.9872L4.67678 15.9874L4.5 15.8107L4.67678 15.9874C4.67687 15.9874 4.67696 15.9873 4.67705 15.9872ZM14.5126 3.32323C14.8408 2.99504 15.2859 2.81067 15.75 2.81067C16.2141 2.81067 16.6592 2.99504 16.9874 3.32323L16.467 3.84366L16.9874 3.32323L21.1768 7.51257L20.4697 8.21968L21.1768 7.51257C21.505 7.84076 21.6893 8.28588 21.6893 8.75001C21.6893 9.21414 21.505 9.65926 21.1768 9.98745L9.70711 21.4571C9.51957 21.6447 9.26522 21.75 9 21.75H4.5C4.03587 21.75 3.59075 21.5656 3.26256 21.2374C2.93437 20.9093 2.75 20.4641 2.75 20V15.8107C2.75 15.5809 2.79527 15.3533 2.88321 15.141C2.97116 14.9287 3.10006 14.7357 3.26256 14.5732L14.5126 3.32323L15.2052 4.01591L14.5126 3.32323Z",
      fill: "#0A072D"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.0429 5.79289C12.4334 5.40237 13.0666 5.40237 13.4571 5.79289L18.7071 11.0429C19.0976 11.4334 19.0976 12.0666 18.7071 12.4571C18.3166 12.8476 17.6834 12.8476 17.2929 12.4571L12.0429 7.20711C11.6524 6.81658 11.6524 6.18342 12.0429 5.79289Z",
      fill: "#0A072D"
    }, null, -1)
  ])))
}
export default { render: render }